import { defaultPlcStatusLogDto, PlcStatusLogDto } from "src/dtos/plcStatusLog/plcStatusLogDto";

/**
 * EQM1010 DTO (백엔드의 PlcStatusLogDto + 확장 필드에 맞춤)
 */
export interface EQM1010_R01Dto extends PlcStatusLogDto {
    // 확장 필드 (사업장/코드/조회기간)
    compCd: string;
    compNm: string;
    // 쿼리 헤더 매핑용 표시 필드
    plcNo: number;         // "PLC 번호"
    plcName: string;         // "PLC명"
    dataType?: string;      // "데이터종류"
    dataNm?: string;        // "데이터명"
    collectValue?: number;  // "수집데이터값" (value를 숫자로 파싱한 값)
    startDate: string;
    endDate: string;
    date: string;
    codeNm: string;
    plcAddressName: string;

    valueDisplay?: string; // UI 표시용 값
    ref01?: string; // ref01 필드 (정렬 및 매핑용)
    ref01List?: string[];

}

/**
 * EQM1010 기본값 (신규 행 추가시 사용)
 */
export const defaultEQM1010_R01Data: EQM1010_R01Dto = {
    // BaseDto
    ...defaultPlcStatusLogDto,

    // 확장 필드
    compCd: '',
    compNm: '',
    codeNm: '',
    plcNo: 0,
    plcName: '',
    dataType: '',
    dataNm: '',
    collectValue: 0,
    startDate: '',
    endDate: '',
    date: '',
    plcAddressName: '',
    valueDisplay: '',
    ref01: '',
    ref01List: [],
};
